import clsx from 'clsx';

import { Content } from '@/lib';
import { DataLayer } from '@/components';
import styles from './Button.module.scss';
import { Row } from '../../Row';

export function Button({ text, url, fluid }: Content.WithFluid<Content.Button>) {
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <a
        href={url}
        className={clsx(styles.button, 'btn btn-md btn-green shadow-green-lighter-md')}
        onClick={() => {
          if (url.includes('/sign-up')) {
            DataLayer.pushTryForFreeClickEvent('body');
          }
        }}
      >
        {text}
      </a>
    </Row>
  );
}
